import { Dashboard } from '@/components';
import View from '@/components/AccountManagement/Profile/UsersProfile/UsersProfile';

export const UsersProfilePage = () => (
  <Dashboard openLogIn>
    <View />
  </Dashboard>
);
